/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddDocumentsDto } from '../models/AddDocumentsDto';
import type { AddGalleryImagesDto } from '../models/AddGalleryImagesDto';
import type { ExpertProfileResponseDto } from '../models/ExpertProfileResponseDto';
import type { UpdateExpertProfileDto } from '../models/UpdateExpertProfileDto';
import type { UpdateExpertVisibilityDto } from '../models/UpdateExpertVisibilityDto';
import type { UpdateRecurringAvailabilityDto } from '../models/UpdateRecurringAvailabilityDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpertAppProfileService {
    /**
     * Get authenticated expert full profile
     * Returns the complete expert profile including user info, expert details, services, service areas, documents, gallery images, pricing, packages, reviews summary, onboarding progress, and document verification summary.
     * @returns ExpertProfileResponseDto Profile fetched successfully
     * @throws ApiError
     */
    public static expertAppProfileControllerGetProfileV1(): CancelablePromise<ExpertProfileResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/profile',
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Update expert profile
     * Partially updates the expert profile. User fields (name, email, phone, gender, DOB) and expert fields (bio, specializations, modes, experience, education) are updated atomically. Service areas and services use replace-all strategy. Documents are appended.
     * @param requestBody
     * @returns any Profile updated successfully
     * @throws ApiError
     */
    public static expertAppProfileControllerUpdateProfileV1(
        requestBody: UpdateExpertProfileDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/expert-app/profile',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
                409: `Email or phone number already in use`,
            },
        });
    }
    /**
     * Toggle expert visibility in discovery
     * Set is_active=false to go on break — expert will be hidden from the client discovery page and new bookings will be blocked. Set is_active=true to become visible again. Existing bookings and availability windows are not affected.
     * @param requestBody
     * @returns any Visibility updated successfully
     * @throws ApiError
     */
    public static expertAppProfileControllerUpdateVisibilityV1(
        requestBody: UpdateExpertVisibilityDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/expert-app/profile/visibility',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Turn automatic availability on or off
     * When enabled, the app keeps the expert topped up to a rolling 30 days of availability on launch instead of prompting them. The pattern holds local minutes from midnight; the client resolves them to UTC. Disabling stops future top-ups and never deletes availability that already exists.
     * @param requestBody
     * @returns any Recurring availability updated
     * @throws ApiError
     */
    public static expertAppProfileControllerUpdateRecurringAvailabilityV1(
        requestBody: UpdateRecurringAvailabilityDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/expert-app/profile/recurring-availability',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Missing pattern when enabling, or overlapping ranges`,
            },
        });
    }
    /**
     * Add gallery images
     * Updates metadata for already-uploaded gallery images (display order, alt text, profile-picture flag). Images must be uploaded and confirmed first via /media/presigned-url + /media/confirm.
     * @param requestBody
     * @returns any Images added successfully
     * @throws ApiError
     */
    public static expertAppProfileControllerAddImagesV1(
        requestBody: AddGalleryImagesDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/profile/images',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Add certification documents
     * Links already-uploaded documents to the expert profile. Documents should be uploaded first via /media/presigned-url + /media/confirm. New documents are added with status "pending".
     * @param requestBody
     * @returns any Documents added successfully
     * @throws ApiError
     */
    public static expertAppProfileControllerAddDocumentsV1(
        requestBody: AddDocumentsDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/expert-app/profile/documents',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
    /**
     * Get all reviews for authenticated expert
     * Returns paginated visible reviews for the authenticated expert, ordered by most recent first. Includes client name and profile image.
     * @param page Page number (default 1)
     * @param limit Items per page (default 10, max 50)
     * @returns any Reviews fetched successfully
     * @throws ApiError
     */
    public static expertAppProfileControllerGetReviewsV1(
        page?: number,
        limit?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/expert-app/profile/reviews',
            query: {
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized — invalid or missing JWT`,
                403: `Forbidden — user is not an expert`,
            },
        });
    }
}
